<template>
  <div class="w3-main main-container">

    <page-header />

    <div class="w3-container about-container">
      <h1 class="w3-xxxlarge"><b>AGC</b></h1>

      <hr class="w3-round">

      <div class="text" v-html="$t('text')"></div>

      <div class="agc-images-container">
        <div
          class="agc-images-thumbnail"
          v-for="elem in agc"
        >
          <div class="agc-category-name-layer">
            <router-link :to="`/agc/${elem._id}`" v-html="elem.title[locale]" />
          </div>

          <img
            :src="`static/images/agc/thumbnails/${elem.thumbnail}`"
          />
        </div>
      </div>

      <h2 class="w3-xxlarge">
        <b>{{ $t('Referenciák') }}</b>
      </h2>

      <agc-gallery />
    </div>
  </div>
</template>

<i18n>
  {
    "de": {
      "text": "Az AGC Glass Europe építészeti síküveg gyártó termékei közül az Alexy Üvegtechnika Orosháza Kft. által forgalmazott és itt bemutatott anyagok kerülnek leggyakrabban felhasználásra munkáink során.<br>Természetesen az itt felsoroltakon kívül más termékek is beszerezhetők, ennek lehetőségéről kérem érdeklődjön <a class=\"link\" href=\"/#kapcsolat\">elérhetőségeink</a> valamelyikén!",
      "Referenciák": "Referenzen"
    },
    "en": {
      "text": "Az AGC Glass Europe építészeti síküveg gyártó termékei közül az Alexy Üvegtechnika Orosháza Kft. által forgalmazott és itt bemutatott anyagok kerülnek leggyakrabban felhasználásra munkáink során.<br>Természetesen az itt felsoroltakon kívül más termékek is beszerezhetők, ennek lehetőségéről kérem érdeklődjön <a class=\"link\" href=\"/#kapcsolat\">elérhetőségeink</a> valamelyikén!",
      "Referenciák": "References"
    },
    "hu": {
      "text": "Az AGC Glass Europe építészeti síküveg gyártó termékei közül az Alexy Üvegtechnika Orosháza Kft. által forgalmazott és itt bemutatott anyagok kerülnek leggyakrabban felhasználásra munkáink során.<br>Természetesen az itt felsoroltakon kívül más termékek is beszerezhetők, ennek lehetőségéről kérem érdeklődjön <a class=\"link\" href=\"/#kapcsolat\">elérhetőségeink</a> valamelyikén!",
      "Referenciák": "Referenciák"
    }
  }
</i18n>

<script>
  import PageHeader from '@/components/PageHeader';
  import AgcGallery from '@/components/AgcGallery';
  import agc from 'static/data/agc.json';

  export default {
    name: 'agc',
    data() {
      return {
        agc,
      };
    },
    created() {
      document.title = 'AGC | BeCreative';
    },
    mounted() {
      scrollTo(0, 0);
    },
    computed: {
      locale() {
        return this.$store.state.i18n.locale;
      },
    },
    components: {
      PageHeader,
      AgcGallery,
    },
  };

</script>

<style scoped>
  hr {
    width: 50px;
    border: 5px solid;
    color: #eb2e4a !important;
    margin-top: 0px;
  }

  .about-container {
    margin-top: 75px;
    max-width: 1000px;
  }

  .agc-images-container {
    max-width: 1000px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    cursor: pointer;
  }

  .agc-images-thumbnail {
    position: relative;
    margin: 5px;
    width: 31%;
  }

  .agc-images-container img {
    width: 100%;
  }

  @media (max-width: 1100px) {
    .agc-images-container {
      justify-content: center;
    }

    .agc-images-container div {
      width: 100%;
      max-width: 512px;
      margin: 0;
    }
  }

  .agc-category-name-layer {
    position: absolute !important;
    margin: 0 !important;
    height: 100%;
    width: 101%;
    background: rgba(255, 255, 255, 0.7);
    display: table;
  }

  .agc-category-name-layer:hover {
    opacity: 0;
  }

  .agc-category-name-layer a {
    width: 100%;
    margin: 0;
    text-align: center;
    font-weight: 600;
    color: #eb2e4a !important;
    line-height: 1.2;
    display: table-cell;
    vertical-align: middle;
    text-decoration: none;
    font-size: 24px;
  }

</style>



// WEBPACK FOOTER //
// Agc.vue?1288c3d8